//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import menuList from '~/config/navigationMerchants';

export default {
  data() {
    return {
      menuList,
    };
  },

  methods: {
    isCurrentRoute(name) {
      const currentRouteName = this.$route.name;
      return (name === currentRouteName);
    },
  },
};
